<template>
    <div id="gameCard">
      <slot name="image"></slot>
      <div id="publisher-name">
        <div id="pubText"><slot name="publisherName"></slot></div>
      </div>
      <div id="game-profits">{{ CurrencySymbol }} {{ GameProfits }}</div>
      <div id="annual-profit">
        {{ CurrencySymbol }} {{ AnnualProfit }} million / year
      </div>
      <div id="percentChange">Change: {{ AnnualChange }}</div>
    </div>
</template>

<style lang="scss" scoped>
#gameCard {
  color: $black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 30px;
  // background:pink;

  @include respond(phone-only) {
    margin: 20px;
  }
}

#publisher-name {
  color: red;
  width: 175px;
  height: 40px;
  text-align: center;
  color: $white;
  background: linear-gradient($green1, $green2);
  border-radius: 30px;
  margin: 0px 0px 0px 0px;

  @include respond(phone-only) {
    width: 125px;
    height: 20px;
    font-size: 12px;
  }
}

#pubText {
  margin-top: 5px;
  @include respond(phone-only) {
    margin-top: 2px;
  }
}
#game-profits {
  color: $white;
  font-family: Play, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 30px;
  font-weight: bold;
  margin: -15px 0px 0px 0px;
  @include respond(phone-only) {
    font-size: 20px;
    margin: -8px 0px 0px 0px;
  }
}

#annual-profit {
  color: $text_grey3;
  font-size: 16px;
  @include respond(phone-only) {
    font-size: 12px;
  }
}

#percentChange {
  color: $yellow;
  font-size: 16px;
  @include respond(phone-only) {
    font-size: 12px;
  }
}

</style>

<script>
export default {
  props: {
    earningRate: Number,
    annualProfit: Number,
    percentChange: String,
  },
  computed: {
    CurrencySymbol() {
      return this.$store.getters.getCurrencySymbol;
    },

    GameProfits() {
      const GameProfitFactor = this.$store.getters.getGameProfitFactor;
      return this.humanFormat(Math.floor(GameProfitFactor * this.earningRate));
    },
    AnnualProfit() {
      const currencyRate = this.$store.getters.getCurrencyRate;
      return this.humanFormat(Math.floor(this.annualProfit * currencyRate));
    },
    AnnualChange() {
      return this.percentChange;
    },
  },
  methods: {
    humanFormat(profit) {
      return new Intl.NumberFormat().format(profit);
    },
  },
};
</script>